import React, { ReactNode } from "react";
import type { BaseError } from "../utils/baseError";

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback: React.ComponentType<{ baseError: BaseError }>;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error: BaseError | null;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: BaseError): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error });
    console.error("ErrorBoundary", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      const { fallback: FallbackComponent } = this.props;

      console.log("display fallback");
      return <FallbackComponent baseError={error!} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
